<template>
  <div id="memorial-payment">
    <h2 class="text-center">{{ $t('pages.memorial.payment') }}</h2>
    <b-container>
      <ajax-new
        :name="name"
        :uri="uri"
        :id="id"
        :config="{ headers: { 'Content-Language': $translation.getLocale() } }"
      >
        <template slot="submitButton">
          <p class="text-center">{{ $t('pages.memorial.paypal_info') }}</p>
          <paypal-button />
        </template>
      </ajax-new>
    </b-container>
  </div>
</template>

<script>
  import AjaxNew from '@triotech/vue-core/src/components/ajax/AjaxNew';
  import PaypalButton from '@/components/PaypalButton';

  export default {
    name: 'MemorialPayment',
    components: {
      AjaxNew,
      PaypalButton,
    },
    data() {
      const { id } = this.user().memorial;
      return {
        id,
        name: 'subscription',
        uri: `api/memorial/${id}/subscription`,
      };
    },
    mounted() {
      if (_.size(this.user().memorial.subscriptions) === 0) {
        this.$bus.$once(`t-event.new-submit.${this.name}.success`, () => {
          this.$ajax.refresh().then(() => {
            this.$parent.step += 1;
          });
        });
      }
    },
  };
</script>

<style lang="scss" scoped>
  /deep/ form .vue-form-generator{
    margin-top: 20px;
    margin-bottom: 20px;
  }

  #paypal-button-container {
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/Memorial/payment.vue